import React from 'react';

import { SvgIcon } from '@mui/material';
import classNames from 'classnames';

import { useStyles } from '../Icon.styles';
import { LegacyIconProps } from '../Icon.types';

export const Enraged = ({
  size = 'default',
  color = 'secondary',
}: LegacyIconProps) => {
  const { classes } = useStyles();

  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(
        classes[`icon_size_${size}` as const],
        classes[`icon_color_${color}` as const],
      )}
    >
      <path
        d="M10.0781 17.377C13.9614 17.377 17.1094 14.229 17.1094 10.3457C17.1094 6.46245 13.9614 3.31445 10.0781 3.31445C6.19487 3.31445 3.04688 6.46245 3.04688 10.3457C3.04688 14.229 6.19487 17.377 10.0781 17.377Z"
        fill="url(#paint0_radial_4706_230386)"
      />
      <path
        d="M10.0781 17.377C13.9614 17.377 17.1094 14.229 17.1094 10.3457C17.1094 6.46245 13.9614 3.31445 10.0781 3.31445C6.19487 3.31445 3.04688 6.46245 3.04688 10.3457C3.04688 14.229 6.19487 17.377 10.0781 17.377Z"
        fill="url(#paint1_radial_4706_230386)"
      />
      <path
        d="M10.0781 17.377C13.9614 17.377 17.1094 14.229 17.1094 10.3457C17.1094 6.46245 13.9614 3.31445 10.0781 3.31445C6.19487 3.31445 3.04688 6.46245 3.04688 10.3457C3.04688 14.229 6.19487 17.377 10.0781 17.377Z"
        fill="url(#paint2_linear_4706_230386)"
      />
      <path
        d="M10.0781 17.377C13.9614 17.377 17.1094 14.229 17.1094 10.3457C17.1094 6.46245 13.9614 3.31445 10.0781 3.31445C6.19487 3.31445 3.04688 6.46245 3.04688 10.3457C3.04688 14.229 6.19487 17.377 10.0781 17.377Z"
        fill="url(#paint3_radial_4706_230386)"
        fillOpacity="0.8"
      />
      <path
        d="M10.0781 17.377C13.9614 17.377 17.1094 14.229 17.1094 10.3457C17.1094 6.46245 13.9614 3.31445 10.0781 3.31445C6.19487 3.31445 3.04688 6.46245 3.04688 10.3457C3.04688 14.229 6.19487 17.377 10.0781 17.377Z"
        fill="url(#paint4_radial_4706_230386)"
        fillOpacity="0.8"
      />
      <path
        d="M13.003 10.3548C12.3588 10.3548 11.9311 10.1704 11.7139 9.9341C11.6295 9.84191 11.5999 9.71184 11.6366 9.59231C11.6733 9.47277 11.771 9.38176 11.8924 9.35324C13.2163 9.04191 14.112 8.21301 14.3557 8.05051C14.6131 7.87902 14.8256 7.67356 14.9542 7.73176C15.1311 7.81223 14.8819 8.19973 14.7549 8.34738C14.7182 8.38996 14.026 9.18449 12.9827 9.69973C13.2682 9.7091 13.6378 9.64152 14.0202 9.56106C14.2108 9.52121 14.5596 9.38762 14.6163 9.52121C14.6729 9.65481 14.3995 9.93098 14.2307 10.0275C13.876 10.2302 13.3827 10.3552 13.0022 10.3552L13.003 10.3548Z"
        fill="url(#paint5_radial_4706_230386)"
      />
      <path
        d="M13.003 10.3548C12.3588 10.3548 11.9311 10.1704 11.7139 9.9341C11.6295 9.84191 11.5999 9.71184 11.6366 9.59231C11.6733 9.47277 11.771 9.38176 11.8924 9.35324C13.2163 9.04191 14.112 8.21301 14.3557 8.05051C14.6131 7.87902 14.8256 7.67356 14.9542 7.73176C15.1311 7.81223 14.8819 8.19973 14.7549 8.34738C14.7182 8.38996 14.026 9.18449 12.9827 9.69973C13.2682 9.7091 13.6378 9.64152 14.0202 9.56106C14.2108 9.52121 14.5596 9.38762 14.6163 9.52121C14.6729 9.65481 14.3995 9.93098 14.2307 10.0275C13.876 10.2302 13.3827 10.3552 13.0022 10.3552L13.003 10.3548Z"
        fill="#421D30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9466 10.3543C12.9649 10.3547 12.9834 10.3548 13.002 10.3548C13.0021 10.3548 13.0021 10.3548 13.0022 10.3548C13.0025 10.3548 13.0027 10.3548 13.003 10.3548L13.0022 10.3552C13.0025 10.3552 13.0027 10.3552 13.003 10.3552C13.0031 10.3552 13.0031 10.3552 13.0032 10.3552C13.0213 10.3552 13.0397 10.3549 13.0583 10.3543C13.4302 10.3429 13.8932 10.2204 14.2307 10.0275C14.3995 9.93099 14.6729 9.65482 14.6163 9.52122C14.5718 9.41622 14.3468 9.47627 14.1599 9.52614C14.109 9.53972 14.061 9.55254 14.0202 9.56107C13.8604 9.59468 13.703 9.62604 13.5529 9.65049C13.3437 9.68456 13.149 9.7052 12.9827 9.69974C13.1549 9.6147 13.3175 9.52206 13.4692 9.42645C14.2367 8.94273 14.7243 8.38295 14.7549 8.3474C14.8819 8.19974 15.1311 7.81224 14.9542 7.73177C14.8576 7.68802 14.7135 7.79328 14.5385 7.92109C14.4808 7.96329 14.4196 8.00795 14.3557 8.05052C14.3166 8.07659 14.2607 8.11981 14.189 8.1753C13.8136 8.46567 13.0039 9.09187 11.8924 9.35325C11.771 9.38177 11.6733 9.47279 11.6366 9.59232C11.5999 9.71185 11.6296 9.84193 11.7139 9.93411C11.9247 10.1635 12.3338 10.3439 12.9466 10.3543ZM11.8389 9.12508C12.8915 8.87752 13.6476 8.29556 14.0344 7.99786C14.114 7.93655 14.178 7.8873 14.2257 7.85551L14.2258 7.85546C14.2852 7.81587 14.3427 7.77387 14.4015 7.73094L14.4036 7.72937C14.4598 7.68836 14.5194 7.64482 14.5761 7.60818C14.632 7.57204 14.6988 7.5334 14.7697 7.51017C14.8413 7.48674 14.9447 7.47017 15.0509 7.51827L15.0512 7.51842C15.1183 7.54894 15.1734 7.59912 15.2086 7.66532C15.2419 7.72791 15.2504 7.79166 15.2499 7.84332C15.249 7.94154 15.215 8.03734 15.1825 8.11004C15.1151 8.26085 15.0071 8.41359 14.9327 8.5002L14.9324 8.50046C14.9035 8.53403 14.5764 8.90964 14.0408 9.31519C14.0585 9.31061 14.0776 9.30551 14.0985 9.29993C14.1072 9.29761 14.1163 9.29521 14.1256 9.29272C14.1859 9.27671 14.2571 9.25826 14.3262 9.24558C14.3915 9.23358 14.4754 9.22262 14.5561 9.23304C14.6369 9.24348 14.7708 9.28529 14.8321 9.42974C14.8841 9.55241 14.8477 9.67036 14.8182 9.73745C14.7855 9.81178 14.7362 9.88113 14.6873 9.93925C14.59 10.0547 14.4589 10.167 14.3471 10.2309L14.347 10.231C13.9562 10.4543 13.4227 10.5896 13.0022 10.5896L13.0021 10.5892C12.3206 10.589 11.8186 10.3944 11.5414 10.0927L11.541 10.0924C11.4009 9.93928 11.3513 9.72294 11.4125 9.52349C11.4738 9.32417 11.6364 9.17264 11.8388 9.1251"
        fill="url(#paint6_linear_4706_230386)"
      />
      <path
        d="M7.15318 10.3548C7.79732 10.3548 8.22506 10.1704 8.44224 9.9341C8.52662 9.84191 8.55631 9.71184 8.51959 9.59231C8.48287 9.47277 8.38521 9.38176 8.26373 9.35324C6.9399 9.04191 6.0442 8.21301 5.80045 8.05051C5.54303 7.87902 5.33053 7.67356 5.20201 7.73176C5.02506 7.81223 5.27428 8.19973 5.40123 8.34738C5.43795 8.38996 6.13014 9.18449 7.1735 9.69973C6.88795 9.7091 6.51842 9.64152 6.136 9.56106C5.94537 9.52121 5.59654 9.38762 5.5399 9.52121C5.48326 9.65481 5.7567 9.93098 5.92545 10.0275C6.28014 10.2302 6.7735 10.3552 7.15396 10.3552L7.15318 10.3548Z"
        fill="url(#paint7_radial_4706_230386)"
      />
      <path
        d="M7.15318 10.3548C7.79732 10.3548 8.22506 10.1704 8.44224 9.9341C8.52662 9.84191 8.55631 9.71184 8.51959 9.59231C8.48287 9.47277 8.38521 9.38176 8.26373 9.35324C6.9399 9.04191 6.0442 8.21301 5.80045 8.05051C5.54303 7.87902 5.33053 7.67356 5.20201 7.73176C5.02506 7.81223 5.27428 8.19973 5.40123 8.34738C5.43795 8.38996 6.13014 9.18449 7.1735 9.69973C6.88795 9.7091 6.51842 9.64152 6.136 9.56106C5.94537 9.52121 5.59654 9.38762 5.5399 9.52121C5.48326 9.65481 5.7567 9.93098 5.92545 10.0275C6.28014 10.2302 6.7735 10.3552 7.15396 10.3552L7.15318 10.3548Z"
        fill="#421D30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.44225 9.93411C8.23145 10.1635 7.82234 10.3439 7.20954 10.3543C7.19126 10.3547 7.1728 10.3548 7.15416 10.3548C7.15409 10.3548 7.15403 10.3548 7.15396 10.3548C7.1537 10.3548 7.15344 10.3548 7.15318 10.3548L7.15396 10.3552C7.1537 10.3552 7.15344 10.3552 7.15318 10.3552C7.15312 10.3552 7.15305 10.3552 7.15299 10.3552C7.13488 10.3552 7.11652 10.3549 7.09793 10.3543C6.72604 10.3429 6.26296 10.2204 5.92545 10.0275C5.7567 9.93099 5.48326 9.65482 5.5399 9.52122C5.58442 9.41622 5.80943 9.47627 5.99626 9.52614C6.04714 9.53972 6.09519 9.55254 6.136 9.56107C6.29573 9.59468 6.45322 9.62604 6.60327 9.65049C6.81247 9.68456 7.00722 9.7052 7.1735 9.69974C7.0013 9.6147 6.83867 9.52206 6.68697 9.42645C5.91951 8.94273 5.43189 8.38295 5.40123 8.3474C5.27428 8.19974 5.02506 7.81224 5.20201 7.73177C5.29862 7.68802 5.4427 7.79328 5.61765 7.92109C5.67542 7.96329 5.73655 8.00795 5.80045 8.05052C5.83955 8.07659 5.89544 8.11981 5.96718 8.1753C6.34262 8.46567 7.15229 9.09187 8.26373 9.35325C8.38521 9.38177 8.48287 9.47279 8.51959 9.59232C8.55631 9.71185 8.52662 9.84193 8.44225 9.93411ZM8.31738 9.1251C8.51975 9.17264 8.6824 9.32417 8.74363 9.52349C8.8049 9.72294 8.75524 9.93928 8.61514 10.0924L8.61481 10.0927C8.33755 10.3944 7.83561 10.589 7.15406 10.5892L7.15396 10.5896C6.73352 10.5896 6.19995 10.4543 5.80914 10.231L5.80912 10.2309C5.69729 10.167 5.56615 10.0547 5.46889 9.93925C5.41994 9.88113 5.37065 9.81178 5.33796 9.73745C5.30847 9.67036 5.27211 9.55241 5.32412 9.42974C5.38536 9.28529 5.51929 9.24348 5.6001 9.23304C5.68073 9.22262 5.76465 9.23358 5.83002 9.24558C5.89906 9.25826 5.97028 9.27671 6.03056 9.29272C6.03991 9.29521 6.04893 9.29761 6.05764 9.29993C6.07856 9.30551 6.0977 9.31061 6.11534 9.31519C5.5798 8.90964 5.25269 8.53403 5.22374 8.50046L5.22351 8.5002C5.14905 8.41359 5.04111 8.26085 4.97369 8.11004C4.94119 8.03734 4.90718 7.94154 4.90627 7.84332C4.90579 7.79166 4.91433 7.72791 4.94757 7.66532C4.98274 7.59912 5.03788 7.54894 5.10499 7.51842L5.10532 7.51827L5.10532 7.51827C5.21152 7.47017 5.31492 7.48674 5.38646 7.51017C5.45743 7.5334 5.52422 7.57204 5.58013 7.60818C5.6368 7.64482 5.69641 7.68837 5.75254 7.72938L5.75468 7.73094C5.81345 7.77387 5.87095 7.81587 5.93039 7.85546L5.93046 7.85551C5.97815 7.8873 6.04214 7.93655 6.12179 7.99786C6.5086 8.29557 7.26475 8.87755 8.31738 9.1251Z"
        fill="url(#paint8_linear_4706_230386)"
      />
      <path
        d="M10.0792 11.0791C8.27601 11.0791 7.53739 12.7977 7.94168 12.9809C8.03426 13.0222 8.09938 12.9675 8.20639 12.8776C8.43125 12.6887 8.82622 12.1527 10.0792 12.1527C11.3321 12.1527 11.7271 12.6887 11.952 12.8776C12.059 12.9675 12.1241 13.0222 12.2167 12.9809C12.621 12.7977 11.8485 11.0791 10.0792 11.0791Z"
        fill="url(#paint9_radial_4706_230386)"
      />
      <path
        d="M10.0792 11.0791C8.27601 11.0791 7.53739 12.7977 7.94168 12.9809C8.03426 13.0222 8.09938 12.9675 8.20639 12.8776C8.43125 12.6887 8.82622 12.1527 10.0792 12.1527C11.3321 12.1527 11.7271 12.6887 11.952 12.8776C12.059 12.9675 12.1241 13.0222 12.2167 12.9809C12.621 12.7977 11.8485 11.0791 10.0792 11.0791Z"
        fill="#421D30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.82954 13.2302L7.82883 13.2299C7.67952 13.1623 7.60538 13.0301 7.57714 12.9084C7.54991 12.791 7.55896 12.6652 7.58432 12.5484C7.63559 12.3122 7.76862 12.0428 7.96853 11.7912C8.37259 11.2826 9.08309 10.8057 10.0792 10.8057C11.0597 10.8057 11.7692 11.2837 12.1762 11.79C12.3778 12.0408 12.514 12.3094 12.5685 12.5448C12.5954 12.6612 12.6064 12.7871 12.5806 12.905C12.5538 13.0277 12.4803 13.1616 12.3295 13.2299L12.3288 13.2302L12.3281 13.2306C12.2009 13.2873 12.0773 13.2757 11.9716 13.225C11.8978 13.1897 11.8301 13.1325 11.786 13.0953C11.7825 13.0924 11.7792 13.0896 11.7761 13.087C11.7338 13.0515 11.6952 13.0151 11.6557 12.9779C11.5554 12.8836 11.4501 12.7844 11.2682 12.6833C11.0296 12.5506 10.6642 12.4261 10.0792 12.4261C9.49418 12.4261 9.12878 12.5506 8.89013 12.6833C8.7083 12.7844 8.60294 12.8836 8.50269 12.9779C8.46321 13.0151 8.42451 13.0515 8.38225 13.087C8.37911 13.0896 8.37582 13.0924 8.37239 13.0953C8.32828 13.1325 8.26053 13.1897 8.18673 13.225C8.08104 13.2757 7.95743 13.2873 7.83025 13.2306L7.82954 13.2302ZM12.2167 12.9809C12.1241 13.0222 12.059 12.9675 11.952 12.8776C11.9245 12.8545 11.8945 12.8263 11.8607 12.7944C11.6178 12.5658 11.1791 12.1527 10.0792 12.1527C8.97929 12.1527 8.54056 12.5658 8.29768 12.7944C8.26387 12.8263 8.23386 12.8545 8.20639 12.8776C8.09938 12.9675 8.03426 13.0222 7.94168 12.9809C7.53739 12.7977 8.27601 11.0791 10.0792 11.0791C11.8485 11.0791 12.621 12.7977 12.2167 12.9809Z"
        fill="url(#paint10_linear_4706_230386)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4706_230386"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.87191 4.15569) scale(13.1441)"
        >
          <stop stopColor="#FFB9B2" />
          <stop offset="0.43" stopColor="#FF836C" />
          <stop offset="0.7" stopColor="#FF6B49" />
          <stop offset="1" stopColor="#D40E22" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4706_230386"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.89418 4.42026) rotate(54.7041) scale(13.945 13.929)"
        >
          <stop offset="0.608798" stopColor="#FF3737" stopOpacity="0" />
          <stop offset="0.858784" stopColor="#FF79B1" stopOpacity="0.45" />
          <stop offset="0.994222" stopColor="#FF3673" stopOpacity="0.56" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_4706_230386"
          x1="10.0781"
          y1="3.31445"
          x2="10.0781"
          y2="17.377"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF4312" stopOpacity="0" />
          <stop offset="0.714321" stopColor="#FF2C1F" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_4706_230386"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.47489 7.71443) rotate(52.9093) scale(10.0019 11.4862)"
        >
          <stop offset="0.510417" stopColor="#FF4570" stopOpacity="0" />
          <stop offset="0.994222" stopColor="#FA48A8" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_4706_230386"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.0781 10.6659) rotate(-90) scale(7.73511 7.38974)"
        >
          <stop offset="0.848958" stopColor="#FF0C0C" stopOpacity="0" />
          <stop offset="1" stopColor="#FF3939" stopOpacity="0.78" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_4706_230386"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.0458 5.47279) rotate(54.92) scale(4.55703 5.28616)"
        >
          <stop offset="0.87" stopColor="#751900" />
          <stop offset="1" stopColor="#4D1300" />
        </radialGradient>
        <linearGradient
          id="paint6_linear_4706_230386"
          x1="12.7039"
          y1="8.36339"
          x2="13.3183"
          y2="10.4429"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.165468" stopColor="#DD1F05" />
          <stop offset="1" stopColor="#FF8484" />
        </linearGradient>
        <radialGradient
          id="paint7_radial_4706_230386"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.34269 5.31818) rotate(123.49) scale(4.86289 5.49507)"
        >
          <stop offset="0.89" stopColor="#751900" />
          <stop offset="1" stopColor="#4D1300" />
        </radialGradient>
        <linearGradient
          id="paint8_linear_4706_230386"
          x1="7.66304"
          y1="8.33189"
          x2="6.98569"
          y2="10.1119"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.165468" stopColor="#DD1F05" />
          <stop offset="1" stopColor="#FF8484" />
        </linearGradient>
        <radialGradient
          id="paint9_radial_4706_230386"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.99328 14.8207) rotate(-90) scale(3.65742 4.05974)"
        >
          <stop offset="0.52" stopColor="#9B2800" />
          <stop offset="1" stopColor="#4C1200" />
        </radialGradient>
        <linearGradient
          id="paint10_linear_4706_230386"
          x1="10.0779"
          y1="10.5213"
          x2="10.0779"
          y2="13.1519"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.165468" stopColor="#DD1F05" />
          <stop offset="0.694611" stopColor="#FF6161" />
          <stop offset="1" stopColor="#FF8484" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};
